import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CommonService } from 'src/app/shared/services/common.service';
import { HospitalService } from '../../../hospital.service';

@Component({
  selector: 'app-no-coverage',
  templateUrl: './no-coverage.component.html',
  styleUrls: ['./no-coverage.component.css'],
  providers: [DatePipe]
})
export class NoCoverageComponent implements OnInit {

  hospitalProgramId: number;
  hospitalPrograms: any[];
  nextCoverageStartDate: string;
  nextCoverageStartTime: string;
  isAnyFutureCoverage: boolean = true;
  constructor(private activatedRoute: ActivatedRoute, private commonService:CommonService, private hospitalService: HospitalService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.hospitalProgramId = params.hpId == undefined ? null :this.commonService.encryptDecryptValue(params.hpId,false) ;
      if (this.hospitalProgramId != 0 && this.hospitalProgramId != null) {
        this.getNextCoverageStartTime();
      }
    });
  }


  getNextCoverageStartTime() {
    this.hospitalService.getCurrentAvailableDoctorByProgramId(this.hospitalProgramId, 0).subscribe((response: any) => {
      if (response != null && response.nextCoverageTime) {
        //var stillUtc = moment.utc(response.nextCoverageTime).toDate();
        //var local = moment(stillUtc).local();
        //response.nextCoverageTime = local.toDate();
        if (localStorage.getItem('isAdmin')) {
          response.nextCoverageTime = this.commonService.getUserTZDateTime(response.nextCoverageTime);
        }
        else {
          var stillUtc = moment.utc(response.nextCoverageTime).toDate();
          var local = moment(stillUtc).local();
          response.nextCoverageTime = local.toDate();
        }
        this.nextCoverageStartDate = this.datePipe.transform(response.nextCoverageTime, 'MMM-d');
        this.nextCoverageStartTime = response.nextCoverageTime;
      }
      else {
        this.isAnyFutureCoverage = false;
      }
    });
  }
}
